import { useLocation } from 'react-router-dom';

export function useIsDTHFlow() {
  const location = useLocation();
  return location.pathname.includes('/claro-tv');
}

export function useIsGponFlow() {
  const location = useLocation();
  return location.pathname.includes('/dashboard');
}
